export const roles = [
  ['/info-center', '/profile', '/billing', '/games', '/file-manager'], // Role 0 - Basic user with profile access only
  ['/info-center', '/profile', '/billing', '/games', '/file-manager'], // Role 1 - Basic user with profile access only
  [
    '/info-center',
    '/establishements',
    '/classes',
    '/users',
    '/subjects',
    '/remarques',
    '/exams',
    '/national-exams',
    '/admin-documents',
    '/qcm',
    '/exercices',
    '/video-gallery',
    '/quiz-leaderboard',
    '/ranking-board',
    '/grades',
    '/inventory',
    '/inventory-types',
    '/inventory-statistics',
    '/type-exams',
    '/type-remarques',
    '/payment-categories',
    '/payments',
    '/billing',
    '/payroll',
    '/payroll/v2',
    '/payroll-categories',
    '/expenditures',
    '/accounting',
    '/profile',
    '/promotions',
    '/statistiques',
    '/email-management',
    '/users/infos',
    '/games',
    '/file-manager',
    '/zad',
    '/zad/categories',
    '/zad/product-types',
    '/zad/products',
    '/zad/labels',
    '/zad/catalogue',
    '/zad/promotions',
    '/zad/promo-codes',
    '/zad/stock',
    '/zad/stock/replenishment',
    '/zad/procurement',
    '/zad/suppliers',
    '/zad/purchases',
    '/zad/supplier-payments',
    '/zad/customers',
    '/zad/sales',
    '/zad/sales-history',
    '/zad/customer-payments',
    '/zad/customer-returns',
    '/zad/customer-refunds',
    '/zad/reports',
    '/zad/reports/accounting',
    '/zad/settings',
  ], // Role 2 - Admin (Full access + ZAD Library module)
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/qcm', '/grades', '/users/details', '/payments', '/billing', '/payroll', '/games', '/file-manager'], // Role 3 - Teacher
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/payments', '/billing', '/games', '/file-manager'], // Role 4 - Student (Grades = Report card)
  ['/info-center', '/kids', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/payments', '/billing', '/games', '/file-manager'], // Role 5 - Parent (Grades = Report card)
  ['/info-center',  '/profile',  '/accounting', '/admin-documents', '/file-manager', '/users','/zad/reports/accounting', '/zad/sales-history'], // Role 6 - Finance Manager: school finance + school accounting (no dashboard/receipts) + ZAD accounting + sales history. No Paie V2, no payment categories.
  ['/info-center', '/inventory', '/inventory-types', '/profile', '/billing', '/games', '/file-manager'], // Role 7 - Stock Manager
  ['/info-center', '/profile', '/payments', '/billing'], // Role 8 - Limited student (school Comptabilité is roles 2 and 6 only)
  ['/info-center',  '/payroll/v2',  '/profile',  '/users','/accounting', '/admin-documents','/zad/reports/accounting',], // Role 9 - Comptable: payroll V2 + expense-management accounting (no dashboard/receipts/student outstanding/tickets/ZAD financial)
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/subjects', '/users/details', '/expenditures', '/payments', '/billing', '/games', '/file-manager'], // Role 10 - Secretary / Secrétaire (Teacher + Subjects management)
  ['/zad', '/profile', '/zad/categories', '/zad/product-types', '/zad/products', '/zad/labels', '/zad/catalogue', '/zad/promotions', '/zad/promo-codes', '/zad/stock', '/zad/stock/replenishment', '/zad/procurement', '/zad/suppliers', '/zad/purchases', '/zad/supplier-payments', '/zad/customers', '/zad/sales', '/zad/sales-history', '/zad/customer-payments', '/zad/customer-returns', '/zad/customer-refunds', '/zad/reports'], // Role 11 - ZAD Library (frontend shell only; no school modules)
]

export const ZAD_LIBRARY_ROLE = '11'
export const ZAD_LIBRARY_ROLE_INDEX = 11
export const UNKNOWN_ROLE_REDIRECT = '/profile'

/** Registered ZAD routes. Future: /zad/payments */
export const ZAD_REGISTERED_PATHS = ['/zad', '/zad/categories', '/zad/product-types', '/zad/products', '/zad/labels', '/zad/catalogue', '/zad/promotions', '/zad/promo-codes', '/zad/stock', '/zad/stock/replenishment', '/zad/procurement', '/zad/suppliers', '/zad/purchases', '/zad/supplier-payments', '/zad/customers', '/zad/sales', '/zad/sales-history', '/zad/customer-payments', '/zad/customer-returns', '/zad/customer-refunds', '/zad/reports', '/zad/reports/accounting', '/zad/settings'] as const

export const ZAD_FINANCIAL_ROLES = [2, 6] as const
export const ZAD_ACCOUNTING_REPORT_PATH = '/zad/reports/accounting'

export function hasZadFinancialAccess(role: string | number | undefined | null): boolean {
  const index = resolveRoleIndex(role)
  return index === 2 || index === 6
}

export const SCHOOL_ACCOUNTING_PATH = '/accounting'
export const SCHOOL_ACCOUNTING_RECEIPTS_PATH = '/accounting/payments'
export const SCHOOL_ACCOUNTING_EXPENSES_PATH = '/accounting/expenses'
export const SCHOOL_ACCOUNTING_TICKETS_PATH = '/accounting/tickets'
export const SCHOOL_ACCOUNTING_STUDENT_OUTSTANDING_PATH = '/accounting/student-outstanding'
export const SCHOOL_ACCOUNTING_FINANCE_LANDING_PATH = SCHOOL_ACCOUNTING_STUDENT_OUTSTANDING_PATH
export const PAYROLL_V2_PATH = '/payroll/v2'

export function isPayrollV2Path(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return path === PAYROLL_V2_PATH || path.startsWith(`${PAYROLL_V2_PATH}/`)
}

/** Payroll V2 domain access used by adapters: roles 2, 6, 9. */
export function hasPayrollV2Access(role: string | number | undefined | null): boolean {
  const index = resolveRoleIndex(role)
  return index === 2 || index === 6 || index === 9
}

/** Payroll V2 menu and routes: admin (2) and accountant (9). Finance manager (6) is hidden. */
export function hasPayrollV2NavAccess(role: string | number | undefined | null): boolean {
  const index = resolveRoleIndex(role)
  return index === 2 || index === 9
}

/** Backend PAYROLL_VIEW_SENSITIVE: roles 2, 6, 9. */
export function hasPayrollV2SensitiveAccess(role: string | number | undefined | null): boolean {
  return hasPayrollV2Access(role)
}

/** Backend PAYROLL_DELETE (terminate): role 2 only. */
export function hasPayrollV2TerminateAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Backend PAYROLL_VALIDATE / PAYROLL_RULE_APPROVE: role 2 only. */
export function hasPayrollV2ApproveAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Backend historical ENDED overlap acknowledgment: Admin role 2 only. Roles 6/9 may prepare DRAFT. */
export function hasPayrollV2HistoricalOverlapAckAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Backend admin-void / admin-delete: Admin role 2 only. Not ordinary employment termination. */
export function hasPayrollV2AdminContractMutationAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Backend PAYROLL_RULE_DRAFT / assertAdminLegalDraft: role 2 only. */
export function hasPayrollV2LegalDraftAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Backend authorize-simulation: Admin role 2 only. Roles 6/9 may consume authorized drafts. */
export function hasPayrollV2AuthorizeSimulationAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Backend hasAnyAccountingAccess: admin (2) and finance manager (6) only. Role 8/9 are not general accounting. */
export function hasSchoolAccountingAccess(role: string | number | undefined | null): boolean {
  const index = resolveRoleIndex(role)
  return index === 2 || index === 6
}

/** Comptabilité module entry (expense-management subset for Role 9). Roles 2, 6 and 9. */
export function hasSchoolAccountingExpenseManagementAccess(
  role: string | number | undefined | null
): boolean {
  const index = resolveRoleIndex(role)
  return index === 2 || index === 6 || index === 9
}

/** GET /api/accounting/summary and other general-accounting KPIs: roles 2 and 6 only. */
export function hasSchoolAccountingSummaryAccess(role: string | number | undefined | null): boolean {
  return hasSchoolAccountingAccess(role)
}

export function hasSchoolAccountingTicketsAccess(role: string | number | undefined | null): boolean {
  return hasSchoolAccountingAccess(role)
}

export function hasSchoolAccountingStudentOutstandingAccess(
  role: string | number | undefined | null
): boolean {
  return hasSchoolAccountingAccess(role)
}

/** Role 9 audit UI is expense-related events only. Roles 2 and 6 keep the full history. */
export function hasExpenseScopedAccountingAuditAccess(
  role: string | number | undefined | null
): boolean {
  return resolveRoleIndex(role) === 9
}

/** Admin may choose any establishment. Role 6 stays limited to linked schools on general APIs. */
export function hasAllEstablishmentsAccountingAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

/** Expense management catalog: roles 2, 6 and 9 may use every active school. Role 8 is denied. */
export function hasAllEstablishmentsExpenseManagementAccess(
  role: string | number | undefined | null
): boolean {
  return hasSchoolAccountingExpenseManagementAccess(role)
}

/** Roles 6 and 9 may export only expense-journal. Admin keeps the full report catalog. */
export function hasRestrictedExpenseJournalReportAccess(
  role: string | number | undefined | null
): boolean {
  const index = resolveRoleIndex(role)
  return index === 6 || index === 9
}

/** School Comptabilité writes (expenses, TEJ, follow-ups): roles 2, 6 and 9. */
export function hasSchoolAccountingWriteAccess(role: string | number | undefined | null): boolean {
  return hasSchoolAccountingExpenseManagementAccess(role)
}

export function isSchoolAccountingReceiptsPath(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return path === SCHOOL_ACCOUNTING_RECEIPTS_PATH || path.startsWith(`${SCHOOL_ACCOUNTING_RECEIPTS_PATH}/`)
}

/** Encaissements (/accounting/payments): admin (2) only. Role 6 keeps Comptabilité but not receipts. */
export function hasSchoolAccountingReceiptsAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

export function isSchoolAccountingDashboardPath(pathname: string): boolean {
  return normalizeRoutePath(pathname) === SCHOOL_ACCOUNTING_PATH
}

export function isSchoolAccountingTicketsPath(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return path === SCHOOL_ACCOUNTING_TICKETS_PATH || path.startsWith(`${SCHOOL_ACCOUNTING_TICKETS_PATH}/`)
}

export function isSchoolAccountingStudentOutstandingPath(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return (
    path === SCHOOL_ACCOUNTING_STUDENT_OUTSTANDING_PATH ||
    path.startsWith(`${SCHOOL_ACCOUNTING_STUDENT_OUTSTANDING_PATH}/`)
  )
}

/** Comptabilité tableau de bord: admin (2) only. */
export function hasSchoolAccountingDashboardAccess(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === 2
}

export function schoolAccountingLandingPath(role: string | number | undefined | null): string {
  if (hasSchoolAccountingDashboardAccess(role)) return SCHOOL_ACCOUNTING_PATH
  if (hasSchoolAccountingStudentOutstandingAccess(role)) return SCHOOL_ACCOUNTING_FINANCE_LANDING_PATH
  if (hasSchoolAccountingExpenseManagementAccess(role)) return SCHOOL_ACCOUNTING_EXPENSES_PATH
  return SCHOOL_ACCOUNTING_FINANCE_LANDING_PATH
}

export function isZadAccountingReportPath(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return path === ZAD_ACCOUNTING_REPORT_PATH || path.startsWith(`${ZAD_ACCOUNTING_REPORT_PATH}/`)
}

export const resolveRoleIndex = (role: string | number | undefined | null): number | null => {
  if (role === undefined || role === null) {
    return null
  }

  // 1) Direct numeric roles (e.g. '2', 3, 9 ...)
  const numeric = Number(role)
  if (!Number.isNaN(numeric)) {
    return numeric
  }

  const roleStr = `${role}`.toLowerCase().trim()

  // 2) Named roles coming from backend (e.g. 'ROLE_ACCOUNTANT', 'ACCOUNTANT', etc.)
  const map: Record<string, number> = {
    // Existing numeric mappings can be added here if backend ever sends names
    role_admin: 2,
    admin: 2,
    administrator: 2,
    role_teacher: 3,
    teacher: 3,
    role_student: 4,
    student: 4,
    role_parent: 5,
    parent: 5,
    role_finance: 6,
    finance: 6,
    finance_manager: 6,
    role_accountant: 9,
    accountant: 9,
    comptable: 9,
    role_secretary: 10,
    secretary: 10,
    secretaire: 10,
    role_secretaire: 10,
    zad: 11,
    zad_library: 11,
    role_zad_library: 11,
  }

  if (map[roleStr] !== undefined) {
    return map[roleStr]
  }

  // 3) Try to extract any digits if the role is like 'ROLE_9'
  const match = roleStr.match(/\d+/)
  if (match) {
    const extracted = Number(match[0])
    return Number.isNaN(extracted) ? null : extracted
  }

  return null
}

export function normalizeRoutePath(pathname: string): string {
  if (!pathname) return '/'
  return pathname.length > 1 && pathname.endsWith('/') ? pathname.replace(/\/+$/, '') : pathname
}

/** Configured path prefixes for a role, or null when the role is unknown / unconfigured. */
export function getRolePathPrefixes(role: string | number | undefined | null): string[] | null {
  const roleIndex = resolveRoleIndex(role)
  if (roleIndex === null) return null
  const configured = roles[roleIndex]
  if (!configured?.length) return null
  return configured
}

/**
 * Deny-by-default path check used by PrivateRoutes.
 * Unknown, unresolved, or unconfigured roles never authorize a private path.
 */
export function isPathAuthorizedForRole(
  role: string | number | undefined | null,
  pathname: string
): boolean {
  const userRoles = getRolePathPrefixes(role)
  if (!userRoles) return false

  const path = normalizeRoutePath(pathname)
  if (isPayrollV2Path(path)) {
    return hasPayrollV2NavAccess(role)
  }
  if (isZadAccountingReportPath(path)) {
    return hasZadFinancialAccess(role)
  }
  if (isSchoolAccountingReceiptsPath(path)) {
    return hasSchoolAccountingReceiptsAccess(role)
  }
  if (isSchoolAccountingDashboardPath(path)) {
    return hasSchoolAccountingDashboardAccess(role)
  }
  if (isSchoolAccountingTicketsPath(path)) {
    return hasSchoolAccountingTicketsAccess(role)
  }
  if (isSchoolAccountingStudentOutstandingPath(path)) {
    return hasSchoolAccountingStudentOutstandingAccess(role)
  }

  let authorized = userRoles.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))

  if (
    !authorized &&
    (path === '/national-exams' ||
      path.startsWith('/national-exams/') ||
      path.startsWith('/qcm/') ||
      path === '/qcm')
  ) {
    authorized = userRoles.includes('/national-exams') || userRoles.includes('/exams')
  }

  return authorized
}

export function getUnauthorizedRedirect(role: string | number | undefined | null): string {
  const userRoles = getRolePathPrefixes(role)
  if (!userRoles?.[0]) return UNKNOWN_ROLE_REDIRECT
  return userRoles[0]
}
